<template>
    <div>
        <div class="title">被保企业信息</div>
        <Form :model="form" :label-width="110" class="mt15" :rules="formInsuredRules" ref="form">
            <FormItem label="企业名称：" prop="subjectName" class="w600 mt20">
                <Input v-model="form.subjectName" placeholder="请输入企业名称" :maxlength="50"></Input>
            </FormItem>
            <FormItem label="企业证件类型" class="w600" required>
                <Select v-model="form.idType" disabled>
                    <Option value="UNIFIED_SOCIAL_CREDIT_CODE">统一社会信用代码</Option>
                </Select>
            </FormItem>
            <FormItem label="企业证件编码" class="w600" prop="idNumber">
                <Input v-model="form.idNumber" placeholder="请输入企业证件编码" :maxlength="50"></Input>
            </FormItem>
        </Form>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        info: {
            type: Object,
            default:{}
        },
    },
    data() {
        return {
            loading: false,
            form:this.info||{},
            formInsuredRules: {
                subjectName: [{ required: true, message: '企业名称必填', trigger: 'blur'}],
                idNumber: [{ required: true, message: '企业证件编码必填', trigger: 'blur' }]
            },
        }
    },
    methods: {
        // 校验
        val() {
            return new Promise((resolve, rejct) => {
                this.$refs.form.validate(valid => {
                    resolve(valid ? this.form : false)
                })
            })
        },
        // 回传给父组件，父组件传入开票组件，开票组件的公司名称和社会代码用此组件的值
        // change() {
        //     this.$emit('on-change', this.form)
        // },
        setDateRange(val) {
            console.log(val)
            this.$emit('on-change', this.form)
        }
    }
}
</script>
<style scoped lang="less">
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/common/ApplicantCompanyInsure.vue